import { render, staticRenderFns } from "./PictureCollect.vue?vue&type=template&id=52cc2753&scoped=true"
import script from "./PictureCollect.vue?vue&type=script&lang=js"
export * from "./PictureCollect.vue?vue&type=script&lang=js"
import style0 from "./PictureCollect.vue?vue&type=style&index=0&id=52cc2753&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc2753",
  null
  
)

export default component.exports